"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchDouble = SwitchDouble;
exports.SwitchSingle = SwitchSingle;
var react_1 = __importStar(require("react"));
var _EXPORTS_1 = require("../../../utils/_EXPORTS");
var BlockLabel_1 = require("../BlockLabel");
var styled_1 = require("./styled");
var Tooltip_1 = require("../../../components/Tooltip");
var utilsOolib_1 = require("../../../utilsOolib");
var Typo2_1 = require("../Typo2");
function SwitchDouble(_a) {
    var id = _a.id, valueProp = _a.value, options = _a.options, onChange = _a.onChange, saveValueAsString = _a.saveValueAsString, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var value = saveValueAsString
        ? options.find(function (d) { return d.value === valueProp; })
        : valueProp;
    var handleClick = function () {
        var otherOption = options.find(function (op) { return op.value !== value.value; });
        !disabled &&
            onChange &&
            onChange(id, saveValueAsString ? otherOption.value : otherOption);
    };
    var props = arguments[0];
    var isLeftOptionActive = value === undefined || options[0].value === (value === null || value === void 0 ? void 0 : value.value);
    if (value === undefined)
        throw new Error("You need to pass a value prop to make SwitchDouble work");
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, _EXPORTS_1.getBlockLabelProps)(props))),
        react_1.default.createElement(styled_1.StyledSwitchWrapper, null,
            react_1.default.createElement(Typo2_1.UI_BODY_SM_DF, { lineHeight: 1,
                semibold: isLeftOptionActive ? true : false }, options[0].display),
            react_1.default.createElement(styled_1.StyledButtonSlider, { disabled: disabled, onClick: handleClick },
                react_1.default.createElement(styled_1.StyledSwitch, { className: "StyledSwitch" //read in styled.js why we are using an okf-anti-pattern
                    , disabled: disabled, direction: isLeftOptionActive ? "left" : "right" })),
            react_1.default.createElement(Typo2_1.UI_BODY_SM_DF, { semibold: isLeftOptionActive ? false : true,
                lineHeight: 1 }, options[1].display))));
}
function SwitchSingle(_a) {
    var id = _a.id, value = _a.value, option = _a.option, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, saveValueAsString = _a.saveValueAsString, _c = _a.layoutStyle, layoutStyle = _c === void 0 ? "style1" : _c, infoTooltip = _a.infoTooltip;
    var props = arguments[0];
    var localize = (0, utilsOolib_1.useLocale)();
    /**
     * very important that we check this way,
     * as opposed to checking as 'value === undefined'
     *
     * because in some cases in the TCI, the initial value
     * is not equal to undefined. it is equal to 'false' or something else
     */
    var isInactive = saveValueAsString
        ? value !== option.value
        : (value === null || value === void 0 ? void 0 : value.value) !== option.value;
    var _d = (0, react_1.useState)(isInactive ? "left" : "right"), currentDirection = _d[0], setCurrentDirection = _d[1];
    (0, react_1.useEffect)(function () {
        if (!disabled) {
            setCurrentDirection(isInactive ? "left" : "right");
        }
    }, [isInactive, disabled]);
    var handleClick = function (v) {
        !disabled &&
            onChange &&
            onChange(id, isInactive ? (saveValueAsString ? option.value : option) : undefined);
    };
    var genSwitch = function () {
        console.log("Rendering genSwitch:", {
            currentDirection: currentDirection,
            isInactive: isInactive,
            disabled: disabled,
        });
        return (react_1.default.createElement(styled_1.StyledButtonSlider, { inactive: isInactive, disabled: disabled, onClick: handleClick },
            react_1.default.createElement(styled_1.StyledSwitch, { className: "StyledSwitch" //read in styled.js why we are using an okf-anti-pattern
                , direction: currentDirection, inactive: isInactive, disabled: disabled })));
    };
    var injectOptionalLabelIntoDisplayText = function (_a) {
        var label = _a.label, display = _a.display, isRequired = _a.isRequired;
        if (!!label)
            return display; //if label exists, we do nothing, cuz optional label in that case, would be shown next to the label
        //else
        if (isRequired === false)
            return display + " (".concat(localize("optional"), ")");
        //else
        return display; //cuz ofcourse its not optional, so no need to show optional label
    };
    var genDisplayText = function () { return (react_1.default.createElement(Typo2_1.UI_BODY_SM_DF, { disabled: disabled }, injectOptionalLabelIntoDisplayText({
        display: option.display,
        label: props.label,
        isRequired: props.isRequired
    }))); };
    var genSwitchDisplay = function () {
        return infoTooltip ? (react_1.default.createElement("div", { style: { display: "flex", gap: ".5rem", alignItems: "center" } },
            genDisplayText(),
            react_1.default.createElement(Tooltip_1.Tooltip, __assign({ presetTarget: "infoIcon" }, infoTooltip)))) : (genDisplayText());
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({ hideOptionalLabel: !!props.label === false }, (0, _EXPORTS_1.getBlockLabelProps)(props))),
        layoutStyle === "style1" ? (react_1.default.createElement(styled_1.StyledSwitchWrapper, null,
            genSwitch(),
            genSwitchDisplay())) : (layoutStyle === "style2" && (react_1.default.createElement(styled_1.StyledSwitchWrapper, null,
            genSwitchDisplay(),
            genSwitch())))));
}
